import type { SxProps, Theme } from '@mui/material/styles';

import { signupDisabledButtonStyles, signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

const applicationButtonBlue = '#0090fa';
const applicationButtonBlueHover = '#007dcc';

export const signupSubscriptionTokenStyles = {
  productSection: signupPageStyles.productSection,
  accountHeading: signupPageStyles.accountHeading,
  input: (theme: Theme): SxProps<Theme> => ({
    ...signupPageStyles.input(),
    '& .MuiOutlinedInput-root': {
      height: '49px',
      minHeight: '49px',
      color: theme.palette.text.primary,
      bgcolor: theme.palette.background.paper,
      fontSize: signupTypography.standard,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.divider,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      '&::placeholder': {
        color: theme.palette.text.primary,
        opacity: 1,
      },
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary,
      fontSize: signupTypography.standard,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
  }),
  resetButton: signupPageStyles.inlineAction,
  tokenConfirmation: (theme: Theme): SxProps<Theme> => ({
    display: 'grid',
    gap: 1,
    p: 2.5,
    border: `1px solid ${theme.palette.success.main}`,
    borderRadius: 1,
    bgcolor: theme.palette.success.light,
    '& .MuiTypography-root': {
      fontSize: signupTypography.standard,
    },
  }),
  tokenPanel: (isProductView = false): SxProps<Theme> => ({
    display: 'grid',
    minWidth: 0,
    gridTemplateColumns: { xs: '1fr', sm: '1fr auto' },
    gap: 1.5,
    mb: isProductView ? 0 : 3.5,
  }),
  useTokenButton: (theme: Theme): SxProps<Theme> => ({
    height: '49px',
    minHeight: '49px',
    px: 3,
    border: '1px solid #6bc0ff',
    bgcolor: applicationButtonBlue,
    color: theme.palette.common.white,
    fontSize: signupTypography.standard,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: applicationButtonBlueHover,
      bgcolor: applicationButtonBlueHover,
    },
    '&:focus-visible': {
      outline: '3px solid rgba(0, 144, 250, 0.35)',
      outlineOffset: '3px',
    },
    '&.Mui-disabled': {
      ...signupDisabledButtonStyles,
    },
  }),
};
